var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreaccrumbbackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Breaccrumb_back_button",
    "data-name": "Breaccrumb back button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.438,
    height: 22.589,
    viewBox: "0 0 14.438 22.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Breaccrumb_back_button-2",
    "data-name": "Breaccrumb back button",
    d: "M22.588,14.438,11.132,4.486,0,14.438V10.294L11.1,0l11.49,10.275Z",
    transform: "translate(0 22.589) rotate(-90)",
    fill: "#56aa1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreaccrumbbackbutton);
export default __webpack_public_path__ + "static/media/Breaccrumb back button.e4f7b3f590843d4626956c258d758de4.svg";
export { ForwardRef as ReactComponent };